<template>
  <a @click="open"><slot /></a>
</template>

<script>
import appCan from 'bits/app_can'
import postMessage from 'native_bridge/post_message'
import { openLink } from 'native_bridge/actions'

export default {
  props: {
    bridgeTarget: {
      type: String,
      default: 'external',
    },
  },
  methods: {
    open (event) {
      let url = this.$el.getAttribute('href')

      if (appCan('postMessage')) {
        event.preventDefault()
        // prepend host and protocol to links if they are not already there
        if (!/^https?:\/\//.test(url) && !/^\/\//.test(url)) {
          url = `${window.location.protocol}//${window.location.host}/${url}`
        }
        postMessage(openLink(url, this.bridgeTarget))
        return false
      }
      return true
    },
  },
}
</script>
